"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ECommLoginServiceConfiguration", {
  enumerable: true,
  get: function get() {
    return _ECommLoginServiceConfiguration["default"];
  }
});
Object.defineProperty(exports, "ECommLoginServiceConfigurationUAT", {
  enumerable: true,
  get: function get() {
    return _ECommLoginServiceConfigurationUAT["default"];
  }
});
Object.defineProperty(exports, "ECommLoginServiceConfigurationPPE", {
  enumerable: true,
  get: function get() {
    return _ECommLoginServiceConfigurationPPE["default"];
  }
});
Object.defineProperty(exports, "ECommLoginServiceConfigurationProd", {
  enumerable: true,
  get: function get() {
    return _ECommLoginServiceConfigurationProd["default"];
  }
});
Object.defineProperty(exports, "LegalECommLoginServiceConfiguration", {
  enumerable: true,
  get: function get() {
    return _LegalECommLoginServiceConfiguration["default"];
  }
});
Object.defineProperty(exports, "LegalECommLoginServiceConfigurationUAT", {
  enumerable: true,
  get: function get() {
    return _LegalECommLoginServiceConfigurationUAT["default"];
  }
});
Object.defineProperty(exports, "LegalECommLoginServiceConfigurationPPE", {
  enumerable: true,
  get: function get() {
    return _LegalECommLoginServiceConfigurationPPE["default"];
  }
});
Object.defineProperty(exports, "LegalECommLoginServiceConfigurationProd", {
  enumerable: true,
  get: function get() {
    return _LegalECommLoginServiceConfigurationProd["default"];
  }
});
exports["default"] = void 0;

var _ECommLoginService = _interopRequireDefault(require("./ECommLoginService"));

var _ECommLoginServiceConfiguration = _interopRequireDefault(require("./configurations/ECommLoginServiceConfiguration"));

var _ECommLoginServiceConfigurationUAT = _interopRequireDefault(require("./configurations/ECommLoginServiceConfigurationUAT"));

var _ECommLoginServiceConfigurationPPE = _interopRequireDefault(require("./configurations/ECommLoginServiceConfigurationPPE"));

var _ECommLoginServiceConfigurationProd = _interopRequireDefault(require("./configurations/ECommLoginServiceConfigurationProd"));

var _LegalECommLoginServiceConfiguration = _interopRequireDefault(require("./configurations/LegalECommLoginServiceConfiguration"));

var _LegalECommLoginServiceConfigurationUAT = _interopRequireDefault(require("./configurations/LegalECommLoginServiceConfigurationUAT"));

var _LegalECommLoginServiceConfigurationPPE = _interopRequireDefault(require("./configurations/LegalECommLoginServiceConfigurationPPE"));

var _LegalECommLoginServiceConfigurationProd = _interopRequireDefault(require("./configurations/LegalECommLoginServiceConfigurationProd"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _ECommLoginService["default"];
exports["default"] = _default;